export const truncateUUID = (uuid: string) => {
  return uuid.split('-')[0]
}
